import {
  ContentHeader,
  LinkButton,
  SupportButton,
} from '@backstage/core-components';

import { Typography } from '@material-ui/core';
import { useStyles } from './header.style';

type HeaderProps = {
  exploreCostsUrl?: string;
};

function Header({ exploreCostsUrl }: Readonly<HeaderProps>) {
  const { classes } = useStyles();

  return (
    <section className={classes.header}>
      <div>
        <ContentHeader title="Cost" />
        <div className={classes.reportAndSupportButtonGroup}>
          <LinkButton
            disabled={!exploreCostsUrl}
            variant="contained"
            color="primary"
            to={exploreCostsUrl ?? ''}
          >
            Explore detailed cost report
          </LinkButton>
          <SupportButton
            title="Helps you quickly spot cost issues and take action."
            items={[
              {
                title: 'INFSUPP',
                icon: 'support',
                links: [
                  {
                    title: 'Create a ticket for Triton',
                    url: 'https://zf-scalar.atlassian.net/secure/CreateIssueDetails!init.jspa?pid=13079&issuetype=10672&summary=Cost%20scorecard%20feedback&customfield_12107=11359',
                  },
                ],
              },
              {
                title: 'SAM chatbot',
                icon: 'support',
                links: [
                  {
                    title: 'Ask your questions to our AI bot',
                    url: 'https://sam.eu1.scalar.zf.com/',
                  },
                ],
              },
              {
                title: 'FAQ',
                icon: 'support',
                links: [
                  {
                    title: 'Read more on Confluence',
                    url: 'https://zf-scalar.atlassian.net/wiki/spaces/INFINITY/pages/4556390644/How+to+view+the+log+cost',
                  },
                ],
              },
            ]}
          />
        </div>
      </div>

      <Typography variant="body1">
        This page provides a clear overview of key cost factors for one or more
        teams, highlighting the most impactful areas to manage and optimize. By
        understanding these cost components, you can identify specific actions
        to improve your cost efficiency and achieve an optimal score. With these
        insights, you'll be equipped to keep your team's expenses under control,
        making informed decisions that align with budget goals. This page is
        still under construction and will track more cost categories in the
        future.
      </Typography>
    </section>
  );
}

export { Header };
